import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  envName: 'development',
  apiBaseUrl: 'https://api.dev.projetotrivia.com',
  enableDebugLogs: true,
};
